import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingAndErrors } from '../LoadingAndErrors'
import { PerModal } from '../Modal'
import { updateOnboardingDate, useOnboardingData } from './Queries'
import './index.less'
import { localStorageKey } from '../../../context/auth-client'

export const Onboarding: FC = () => {
  const [dismissed, setDismissed] = useState(false)
  const [iframeUrl, setIframeUrl] = useState<string | null>(null)
  const [t] = useTranslation()
  const iframeId = 'ds-19ecf359-8987-4668-9c9d-99f5137ea55b'
  const { data, loading, error } = useOnboardingData(iframeId)

  const authToken = localStorage.getItem(localStorageKey)

  const handleDismiss = () => {
    setDismissed(true)
    updateOnboardingDate()
  }

  useEffect(() => {
    const setupCookieAndLoadIframe = async () => {
      if (!data || !data.getOnboardingData || !authToken) return

      const setCookieUrl = new URL(data.getOnboardingData.setCookieUrl)

      try {
        const res = await fetch(setCookieUrl.toString(), {
          method: 'GET',
          credentials: 'include',
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })

        if (res.status === 204) {
          setIframeUrl(
            `${data.getOnboardingData.authUrl}?${data.getOnboardingData.queryParamsString}&${data.getOnboardingData.redirectUrlQueryParamName}=${data.getOnboardingData.damUrl}`,
          )
        } else {
          console.error('Set-cookie failed', res.statusText)
        }
      } catch (err) {
        console.error('Error setting auth cookie', err)
      }
    }

    setupCookieAndLoadIframe()
  }, [data, authToken])

  if (loading || error || !data) {
    return <LoadingAndErrors isLoading={loading} hasNoData={!data} error={error} />
  }
  return !dismissed && iframeUrl ? (
    <PerModal
      visible
      closable
      maskClosable={false}
      destroyOnClose
      onCancel={handleDismiss}
      title={{ heading: t('onboardingModal.title') }}
      size="xlarge"
    >
      <div className="onboarding-container">
        <iframe
          id={iframeId}
          title={t('onboardingModal.title')}
          src={iframeUrl}
          className="onboarding-responsive-iframe"
          allowFullScreen
          allow="autoplay; fullscreen; encrypted-media"
          frameBorder={0}
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </PerModal>
  ) : null
}
